import { render } from "./BaseTabs.vue?vue&type=template&id=2f21afac&scoped=true"
import script from "./BaseTabs.vue?vue&type=script&lang=js"
export * from "./BaseTabs.vue?vue&type=script&lang=js"

import "./BaseTabs.vue?vue&type=style&index=0&id=2f21afac&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f21afac"]])

export default __exports__